export var CardholderAvatarSizes;
(function (CardholderAvatarSizes) {
    CardholderAvatarSizes["small"] = "small";
    CardholderAvatarSizes["medium"] = "medium";
    CardholderAvatarSizes["large"] = "large";
})(CardholderAvatarSizes || (CardholderAvatarSizes = {}));
export var CardholderAvatarVariants;
(function (CardholderAvatarVariants) {
    CardholderAvatarVariants["master"] = "master";
    CardholderAvatarVariants["visa"] = "visa";
    CardholderAvatarVariants["card"] = "card";
})(CardholderAvatarVariants || (CardholderAvatarVariants = {}));
//# sourceMappingURL=constants.js.map